import React from 'react';
import { Layout, Menu } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  UserOutlined,
  VideoCameraOutlined,
  PictureOutlined,
  CompassOutlined,
  AppstoreOutlined,
  HomeOutlined,
  CustomerServiceOutlined,
  DashboardOutlined,
  SettingOutlined,
  CreditCardOutlined,
  ToolOutlined,
  BellOutlined,
  MobileOutlined,
  FlagOutlined,
  GlobalOutlined,
  TableOutlined,
  SearchOutlined
} from '@ant-design/icons';
import './SideMenu.css';

const { Sider } = Layout;

const SideMenu = ({ collapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Opening a page from the sidebar always starts it fresh (page 1, default filters)
  const goTo = (path) => {
    try {
      Object.keys(sessionStorage)
        .filter((key) => key.endsWith('TableState'))
        .forEach((key) => sessionStorage.removeItem(key));
    } catch {}
    // The stamp makes App remount the page (see AppRoutes)
    navigate(path, { state: { sidebarNav: Date.now() } });
    window.scrollTo(0, 0);
  };

  const menuItems = [
    { 
      key: '/', 
      label: 'Dashboard', 
      icon: <DashboardOutlined />, 
      onClick: () => goTo('/') 
    },
    { 
      key: 'users', 
      label: 'Users', 
      icon: <UserOutlined />, 
      onClick: () => goTo('/users') 
    },
    { key: 'videos', label: 'Videos', icon: <VideoCameraOutlined />, onClick: () => goTo('/videos') },
    { key: 'images', label: 'Images', icon: <PictureOutlined />, onClick: () => goTo('/images') },
    { key: 'explore', label: 'Explore', icon: <CompassOutlined />, onClick: () => goTo('/explore') },
    { key: 'categories', label: 'Categories', icon: <AppstoreOutlined />, onClick: () => goTo('/categories') },
    { key: 'tools', label: 'Tools', icon: <ToolOutlined />, onClick: () => goTo('/tools') },
    { key: 'banners', label: 'Banner Groups', icon: <FlagOutlined />, onClick: () => goTo('/banners') },
    { key: 'tabs', label: 'Tabs', icon: <TableOutlined />, onClick: () => goTo('/tabs') },
    { key: 'search', label: 'Search', icon: <SearchOutlined />, onClick: () => goTo('/search') },
    { key: 'feed', label: 'Feed', icon: <HomeOutlined />, onClick: () => goTo('/feed') },
    { key: 'notifications', label: 'Notifications', icon: <BellOutlined />, onClick: () => goTo('/notifications') },
    { key: 'support', label: 'Support', icon: <CustomerServiceOutlined />,onClick: () => goTo('/support')},
    { 
      key: 'credit-products', 
      label: 'Credit Products', 
      icon: <CreditCardOutlined />, 
      onClick: () => goTo('/credit-products') 
    },
    { 
      key: 'system', 
      label: 'System', 
      icon: <SettingOutlined />, 
      onClick: () => goTo('/system') 
    },
    {
      key: 'app-versions',
      label: 'App Versions',
      icon: <MobileOutlined />,
      onClick: () => goTo('/app-versions')
    },
    {
      key: 'remote-configs',
      label: 'Remote Configs',
      icon: <GlobalOutlined />,
      onClick: () => goTo('/remote-configs')
    },
  ];

  return (
    <Sider
      collapsed={collapsed}
      className="side-menu"
      trigger={null}
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        items={menuItems}
      />
    </Sider>
  );
};

export default SideMenu; 